<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <vue-dividing-line title="內容及答案"></vue-dividing-line>
      <el-radio-group v-model="createType" size="small">
        <el-radio label="2" >變數</el-radio>
        <el-radio label="1" >定數</el-radio>
      </el-radio-group>
      <br/><br/>
      <div><i class="el-icon-warning-outline"></i> 將需要填入答案的地方以英文符號()括住。</div>
      <div v-if="createType == 2"><i class="el-icon-warning-outline"></i> 選擇變數時輸入範圍用英文符號~隔開。</div>
      <br/>

      <div v-if="false">
        <div class="required">第一列 *</div>
        <el-form-item label="數字" prop="num1">
          <el-input v-model="rulesForm.num1" placeholder="請輸入數字"></el-input>
        </el-form-item>

        <div class="required">第二列 *</div>
        <el-form-item label="數字" prop="num2">
          <el-input v-model="rulesForm.num2" placeholder="請輸入數字"></el-input>
        </el-form-item>

        <div class="add-new-column" @click="addNewColumn" v-if="!thirdlyColumn && rulesForm.sumType == 'add'">
          <i class="el-icon-circle-plus-outline"></i>
          <span class="add-text">添加</span>
          <span class="column">一列</span>
        </div>
        <div v-if="thirdlyColumn" style="display: flex; align-items: center;">
          <span class="required">第三列 *</span>
          <div class="remove-new-column" @click="removeNewColumn">
            <i class="el-icon-remove-outline"></i>
            <span class="add-text">移除</span>
          </div>
        </div>
        <el-form-item label="數字" prop="num3" v-if="thirdlyColumn">
          <el-input v-model="rulesForm.num3" placeholder="請輸入數字"></el-input>
        </el-form-item>

        <div class="required">運算符號 *</div>
        <el-form-item label="" >
          <el-radio-group v-model="rulesForm.sumType" size="small" class="sumType">
            <el-radio :label="its.value" v-for="(its, idx) in sumType" :key="idx">{{ its.label }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="required">算術題答案 *</div>
        <el-form-item label="數字" prop="num4">
          <el-input v-model="rulesForm.num4" placeholder="請輸入數字"></el-input>
        </el-form-item>
      </div>
      <Tinymce v-model="topic" ref="Tinymce"></Tinymce>

      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'

import rules from "../plugins/validator";

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce },
  data() {
    var validatePass = (rule, value, callback) => {
      // console.log(value)
      let regex = value.match(/\(.+?\)/g)
      if(regex) {
        for(let i = 0; i < regex.length; i++) {
          let cte = regex[i].substring(1, regex[i].length - 1)
          if(Number(cte) != cte) {
            return callback(new Error('符號內存在非數字字符'));
          } else if(cte.length > 1) {
            return callback(new Error('符號內只能存在一个數字'));
          }
        }
      }

      callback();
    };

    return {
      topic: '',
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],

      rulesForm: {
        num3: ''
      },
      rules: {
        ...rules,
        num1: [
          { required: true, message: '請輸入數字', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' }
        ],
        num2: [
          { required: true, message: '請輸入數字', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' }
        ],
        num3: [
          { required: true, message: '請輸入數字', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' }
        ],
        num4: [
          { required: true, message: '請輸入數字', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' }
        ],
      },
      units: [],

      createType: '2',
      sumType: [
        { label: '+', value: 'add'},
        { label: '-', value: 'reduce'},
        { label: '*', value: 'ride'},
      ],

      numList: [],
      errMsg: '',
      thirdlyColumn: false
    };
  },
  watch: {
    'topic': function (v) {
      this.strConvertDom(v)
    },
    'createType': function () {
      this.strConvertDom(this.topic)
    }
  },
  methods: {
    strConvertDom(data) {
      this.errMsg = ''
      let parser = new DOMParser(),
      doc = parser.parseFromString(data, 'text/html'),
      tr = doc.querySelectorAll('tr'),
      dataArr = []
      
      if(tr.length == 0) return 

      let regex = null, 
      i = 0
      if(this.createType == 1) {
        regex = /^((((\d)|(\(\d\)))+)|(\(\)))?$/
      } else {
        regex = /^(?:\d+(?:~\d+)?|()|\(\))$/
      }
      
      for(; i < tr.length; i ++) {
        dataArr[i] = []
        let j = 0
        let td = tr[i].querySelectorAll('td')
        for(;j < td.length; j++) {

          dataArr[i].push(td[j].innerText)
        }
        if(j != 2) {
          this.errMsg = '表格只允許2列'
          return ;
        }
      }

      if(i != 3 && i != 4) {
        this.errMsg = '表格只允許3行或4行'
        return ;
      }

      // console.log(dataArr)
      this.rulesForm.num1 = dataArr[0][1]
      this.rulesForm.num2 = dataArr[1][1]
      if(dataArr.length == 3) {
        this.thirdlyColumn = false
        this.rulesForm.num4 = dataArr[2][1]
        let sumType = this.sumType.filter(its => its.label == dataArr[1][0].trim() && its).map(its => its.value)[0]
        this.rulesForm.sumType = sumType

        let {num4} = this.rulesForm

        if(dataArr[0][0].trim() != '' || dataArr[2][0].trim() != '') {
          this.errMsg = '第一列除了第二行，其他都應為空'
          return ;
        }

        if(num4.trim() != '' && !regex.test(num4)) {
          this.errMsg = '第三個數位不符合要求'
          return ;
        }
      }else if(dataArr.length == 4) {
        this.thirdlyColumn = true
        this.rulesForm.num3 = dataArr[2][1]
        this.rulesForm.num4 = dataArr[3][1]
        let sumType = this.sumType.filter(its => its.label == dataArr[2][0].trim() && its).map(its => its.value)[0]
        this.rulesForm.sumType = sumType
        let {num3, num4} = this.rulesForm

        if(dataArr[0][0].trim() != '' || dataArr[1][0].trim() != '' || dataArr[3][0].trim() != '') {
          this.errMsg = '第一列除了第三行，其他都應為空'
          return ;
        }

        if(num3.trim() != '' &&!regex.test(num3)) {
          this.errMsg = '第三個數位不符合要求'
          return ;
        }
        if(num4.trim() != '' &&!regex.test(num4)) {
          this.errMsg = '第四個數位不符合要求'
          return ;
        }
      }

      let {num1, num2, sumType} = this.rulesForm
      if(num1.trim() != '' &&!regex.test(num1)) {
        this.errMsg = '第一個數位不符合要求'
        return ;
      }

      if(num2.trim() != '' && !regex.test(num2)) {
        this.errMsg = '第二個數位不符合要求'
        return ;
      }

      if(!sumType) {
        this.errMsg = '運算子不符合要求'
        return ;
      }

      // console.log(this.rulesForm)
    },
    preview() {
      let res = this.handleFromData()
      // console.log(res)
      if(res) {
        let {form, type} = res
        console.log(form, type)
        this.$emit('preview', form)
      }
    },
    // 新增第三列
    addNewColumn() {
      this.thirdlyColumn = true
    },
    // 移除第三列
    removeNewColumn() {
      this.thirdlyColumn = false
      this.rulesForm.num3 = undefined
    },

    save(equation) {
      // 算出所有值
      let {num1, num2, num3, num4} = equation,
      arr = [[], [], []], 
      regex = /\(\d+\)/g

      let copyNum1 = num1.replace(regex, '*'),
      copyNum2 = num2.replace(regex, '*'),
      copyNum3 = num3 ? num3.replace(regex, '*') : '',
      copyNum4 = num4.replace(regex, '*')
      
      let leng = Math.max((copyNum1).length, (copyNum2).length, (copyNum4).length)
      if(num3 != undefined) {
        leng = Math.max(leng, (copyNum3).length)
        arr.push([])
      }
      while(leng > 0) {
        let regex1 = num1.match(regex), idx1 = regex1 ? regex1[regex1.length - 1].length : 1,
        regex2 = num2.match(regex), idx2 = regex2 ? regex2[regex2.length - 1].length : 1,        
        regex4 = num4.match(regex), idx4 = regex4 ? regex4[regex4.length - 1].length : 1
        if(num3 != undefined) {
          let regex3 = num3.match(regex), idx3 = regex3 ? regex3[regex3.length - 1].length : 1
          idx3 = num3[num3.length - 1] == ')' ? idx3 : 1
          arr[2].unshift(num3.substring([num3.length - idx3]) || '#')
          num3 = num3.substr(0, num3.length - idx3)
        }

        idx1 = num1[num1.length - 1] == ')' ? idx1 : 1
        idx2 = num2[num2.length - 1] == ')' ? idx2 : 1
        idx4 = num4[num4.length - 1] == ')' ? idx4 : 1

        arr[0].unshift(num1.substring([num1.length - idx1]) || '#')
        arr[1].unshift(num2.substring([num2.length - idx2]) || '#')
        arr[arr.length - 1].unshift(num4.substring([num4.length - idx4]) || '#')

        num1 = num1.substr(0, num1.length - idx1)
        num2 = num2.substr(0, num2.length - idx2)
        num4 = num4.substr(0, num4.length - idx4)
        leng --
        
        this.numList = this.handleSum(arr)
      }

      console.log(this.numList)
      this.showEquation = true
    },
    /**
     * 加减乘
     * @param {*} arr
     * [
     *   ['2', '3', '4', '1', '2'],
     *   ['#', '2', '3', '4', '1'],
     *   ['2', '5', '7', '5', '3'], 
     * ]
     */
     handleSum(arr) {
      let newArr = [],
      regex = /\(\d+?\)/g
      newArr = arr.map(its => 
        its.map(item => {
          let bool = item.match(regex)
          if(bool != null) {
            return {num: item.substring(1, item.length - 1), check: true}
          } else {
            return {num: item, check: false}
          }
          
        })
      )

      return newArr
    },

    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },
    handleFromData() {
      let errMsg = this.errMsg,
      topic = this.topic
      if(errMsg || !topic) {
        this.$message.error(errMsg || '請出題')
        return false;
      }

      let form = JSON.parse(JSON.stringify(this.rulesForm)), type = 3, 
      symbol = {
        'add': '+',
        'reduce': '-',
        'ride': '*',
      }
      form.choices = []
      form.answers = []
      console.log(this.createType)
      // 处理數据
      if(this.createType == '2') {
        let {num1, num2, num3, num4, sumType} = form
        let content = {
          first_input: {type: '1', value: num1, range: ''},
          second_input: {type: '1', value: num2, range: ''},
          operator: symbol[sumType],
          result: {type: '1', value: num4, range: ''}
        }, regex = /\(\)|\(\d+?\)/g

        if(num3 != undefined) {
          content.third_input = {type: '1', value: num3, range: ''}
        }

        form.answers.push({value: ''})
        form.choices.push({value: ''})
        
        if(num1.indexOf('~') > -1) {
          content.first_input = {
            type: '0', value: '()', range: num1.replace('~', ',')
          }
        } else if(num1.match(regex)) 
          content.first_input = {
            type: '2', value: '()', range: ''
          }
        console.log(num2, num2.indexOf('~'), 'indexof')
        if(num2.indexOf('~') > -1) {
          content.second_input = {
            type: '0', value: '()', range: num2.replace('~', ',')
          }
        } else if(num2.match(regex)) 
          content.second_input = {
            type: '2', value: '()', range: ''
          }

        if(num3 != undefined && num3.indexOf('~') > -1) {
          content.third_input = {
            type: '0', value: '()', range: num3.replace('~', ',')
          }
        } else if(num3 != undefined && num3.match(regex)) 
          content.third_input = {
            type: '2', value: '()', range: ''
          }

        if(num4.indexOf('~') > -1) {
          content.result = {
            type: '0', value: '()', range: num4.replace('~', ',')
          }
        } else if(num4.match(regex)) 
          content.result = {
            type: '2', value: '()', range: ''
          }
        
        if(num3 != undefined)
          content['is_need_third_input'] = true
        else content['is_need_third_input'] = null

          console.log(content)
        content.html = this.topic
        form.content = JSON.stringify(content)
        type = 8
      } else {
        this.save(form)
        let {numList} = this, str = '', numObj = {0: 'first_input', 1: 'second_input', 2: 'result'},
        content = {
          first_input: '',
          second_input: '',
          operator: symbol[form.sumType],
          result: ''
        }

        if(form.num3 != undefined) {
          numObj[2] = 'third_input'
          content['third_input'] = ''
          numObj[3] = 'result'
        }

        numList.filter((item, idx) => {
          str = ''
          item.filter(its => {
            if(its.check){
              form.answers.push({value: its.num})
              form.choices.push({value: '', position: idx})
              str += '()'
            } else if(its.num != '#') str += its.num
          })
          content[numObj[idx]] = str
        })

        console.log(JSON.parse(JSON.stringify(numList)))
        content.html = this.topic
        console.log(content)
        form.content = JSON.stringify(content)
      }
      
      // 删除多余數据
      delete form.num1
      delete form.num2
      form.num3 != undefined && (delete form.num3)
      delete form.num4
      delete form.sumType
      form.type = type

      return {form, type}
    },
    // 提交
    onSubmit() {
      let res = this.handleFromData()
      
      if(res) {
        let {form, type} = res
        console.log(form, type)
        this.$emit('save', form, type, 3)
      }
      // type, type_display
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {
      ...this.formLabelAlign,
      num1: '',
      num2: '',
      num3: undefined,
      num4: '',
      sumType: 'add'
    }
  },
  mounted() {
    if(this.rulesForm.id) {
      // let symbol = {
      //   '+': 'add',
      //   '-': 'reduce',
      //   '*': 'ride',
      // }
      console.log(this.rulesForm)
      
      // first_input, second_input, third_input, operator, result
      let {html} = JSON.parse(this.rulesForm.content)
      this.topic = html
      this.strConvertDom(html)
      if(this.rulesForm.type == 8) {
        this.createType = '2'
      } if(this.rulesForm.type == 3) {
        this.createType = '1'
      }
      //   // num1
      //   if(first_input.type == 0) this.rulesForm.num1 = first_input.range.replace(',', '~')
      //   else this.rulesForm.num1 = first_input.value

      //   // num2
      //   if(second_input.type == 0) this.rulesForm.num2 = second_input.range.replace(',', '~')
      //   else this.rulesForm.num2 = second_input.value

      //   // num3
      //   if(third_input != undefined) {
      //     if(third_input.type == 0) this.rulesForm.num3 = third_input.range.replace(',', '~')
      //     else this.rulesForm.num3 = third_input.value
      //     this.thirdlyColumn = true
      //   }

      //   // num4
      //   if(result.type == 0) this.rulesForm.num4 = result.range.replace(',', '~')
      //   else this.rulesForm.num4 = result.value
        
      // } else if(this.rulesForm.type == 3) {
      //   this.createType = '1'

      //   this.rulesForm.num1 = first_input
      //   this.rulesForm.num2 = second_input
      //   this.rulesForm.num4 = result

      //   let regex = /\(\)/g
      //   let regex1 = first_input.match(regex)
      //   let regex2 = second_input.match(regex)
      //   let regex4 = result.match(regex)
        
      //   if(regex1) {
      //     for(let i = 0; i < regex1.length; i++) {
      //       first_input = first_input.replace(regex1[i], `(${this.rulesForm.answers[0].value})`)
      //       this.rulesForm.answers.splice(0, 1)
      //     }
      //     this.rulesForm.num1 = first_input
      //   }
        
      //   if(regex2) {
      //     for(let i = 0; i < regex2.length; i++) {
      //       second_input = second_input.replace(regex2[i], `(${this.rulesForm.answers[0].value})`)
      //       this.rulesForm.answers.splice(0, 1)
      //     }
      //     this.rulesForm.num2 = second_input
      //   }

      //   if(third_input != undefined) {
      //     this.rulesForm.num3 = third_input
      //     this.thirdlyColumn = true
      //     let regex3 = third_input.match(regex)
      //     console.log(regex3)
      //     if(regex3) {
      //       for(let i = 0; i < regex3.length; i++) {
      //         third_input = third_input.replace(regex3[i], `(${this.rulesForm.answers[0].value})`)
      //         this.rulesForm.answers.splice(0, 1)
      //       }
      //       this.rulesForm.num3 = third_input
      //     }
          
      //     console.log('this.rulesForm.num', this.rulesForm.num3)
      //   }

      //   if(regex4) {
      //     for(let i = 0; i < regex4.length; i++) {
      //       result = result.replace(regex4[i], `(${this.rulesForm.answers[0].value})`)
      //       this.rulesForm.answers.splice(0, 1)
      //     }
      //     this.rulesForm.num4 = result
      //   }
      // }

      // this.rulesForm.sumType = symbol[operator]
    }

  }
};
</script>

<style lang="scss" scoped>
  .add-new-column {
    width: fit-content;
    padding: 5px 5px;
    border-bottom: 2px solid #F56C6C;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    font-weight: 700;

    i {
      color: #F56C6C;
      margin-right: 10px;
    }

    .add-text {
      color: #F56C6C;
      font-size: 14px;
      margin-right: 10px;
    }
  }

  .remove-new-column {
    width: fit-content;
    padding: 5px 5px;
    border-bottom: 2px solid #F56C6C;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
    margin-left: 50px;

    i {
      color: #F56C6C;
      margin-right: 10px;
    }

    .add-text {
      color: #F56C6C;
      font-size: 14px;
      margin-right: 10px;
    }
  }

  input[type="number"] {
    outline: none;
    width: 70px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding: 0 10px;
    margin-right: 10px;

    &:focus {
      border-color: #409EFF;
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  .select {
    width: 70px;
    margin-right: 10px;
  }

  .equal {
    margin-right: 10px;
  }

  .random-choice {
    width: 100%;

    .random-single {
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .wave {
        margin-right: 10px;
      }
    }

    .random-single:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }

  .sum-region {
    margin-top: 20px;

    $block: 40px;
    $size: 18px;
    $margin: 5px;

    .num, .empty {
      width: $block;
      height: $block;
      box-sizing: border-box;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: $margin;
      font-size: $size;
    }

    .num:hover {
      background-color: #ffcca4;
    }

    .num-select {
      background-color: #ffcca4;
    }
    .canvas {
      padding: 10px;
      box-sizing: border-box;
      
      .num-item {
        width: fit-content;
        padding-left: $block;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: $margin;

        .symbol {
          width: $block;
          height: $block;
          box-sizing: border-box;
          border-radius: 3px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: $margin;
          font-size: $size;
        }

        .fill {
          width: $block;
          height: $block;
          min-width: auto;
          box-sizing: border-box;
          border-radius: 3px;
          outline: none;
          background-color: #fcd2ab;
          border: none;
          text-align: center;
          font-size: $size;
          padding: 0;
          margin-left: $margin;
        }
      }
      .num-item:nth-of-type(2) {
        margin-bottom: 10px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          width: 102%;
          height: 1px;
          background-color: #333;
          bottom: -5px;
          left: 0;
        }

        .symbol {
          position: absolute;
          border: none;
          left: 0;
          top: 0;
          margin: 0;
          cursor: default;
        }
      }
    }
    .division {
      display: flex;
      align-content: flex-start;
      margin-top: 20px;

      .divisor {
        width: fit-content;
        height: 2 * $block;
        display: flex;
        align-items: flex-end;
        margin-right: 20px;
        margin-top: $margin;
      }
      .discuss {
        width: fit-content;
        .single {
          width: fit-content;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: $margin;
        }

        .single:nth-of-type(2n - 1) {
          position: relative;
          
          &:before {
            content: '';
            position: absolute;
            bottom: calc($margin / -2);
            left: 0;
            width: 100%;
            height: 1px;
            background-color: #333;
          }
        }

        .division-style {
          position: absolute;
          width: 20px;
          height: 50px;
          top: calc(100% + $margin / 2);
          left: -20px;
          overflow: hidden;

          &:before {
            content: '';
            position: absolute;
            border-radius: 50%;
            box-sizing: border-box;
            top: -80px;
            left: -60px;
            width: 80px;
            height: 160px;
            border: 1px solid #333;
            border: none;
            border-right: 1px solid #333;
            border-bottom: 1px solid #333;
          }
        }
      }
    }
  }
</style>